import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "px-4 sticky flex items-center",
  style: {"z-index":"50"},
  id: "product-title-nav"
}
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "opacity-0 font-semibold left-1/2 -translate-x-1/2 absolute only-1-lines min-w-64 text-center" }
const _hoisted_6 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_7 = { class: "col-span-12 md:col-span-5 w-full pl-8 overflow-auto max-h-full main-image-container relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 9V3H15",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 15V21H9",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 3L13.5 10.5",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.5 13.5L3 21",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-span-12 md:col-span-7 flex flex-col product-modal__right" }
const _hoisted_12 = { class: "px-4 pb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center gap-2 mb-2" }, null, -1)
const _hoisted_14 = {
  class: "text-xl font-bold",
  id: "product-modal__product-name"
}
const _hoisted_15 = { class: "text-gray-500 max-w-full mb-4 mt-2 text-sm" }
const _hoisted_16 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_17 = { class: "font-bold text-sm" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "De: ", -1)
const _hoisted_19 = { class: "line-through text-red-400" }
const _hoisted_20 = {
  key: 1,
  class: "font-bold flex items-center gap-2"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-md" }, "Por: ", -1)
const _hoisted_22 = { class: "text-green-400 text-success" }
const _hoisted_23 = {
  key: 2,
  class: "font-bold text-neutral-700"
}
const _hoisted_24 = {
  class: "p-4 sticky top-0 z-20 product-modal__right__variation__header",
  style: {"background":"#F9F9F9"}
}
const _hoisted_25 = { class: "flex justify-between items-center" }
const _hoisted_26 = { class: "font-semibold" }
const _hoisted_27 = {
  key: 0,
  class: "relative"
}
const _hoisted_28 = { class: "h-4 w-4 bg rounded-full relative z-10 bg-success" }
const _hoisted_29 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1rem","height":"1rem","z-index":"10"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute top-1/2 -translate-y-1/2 bg-success",
  style: {"width":"100%","height":"4px"}
}, null, -1)
const _hoisted_33 = {
  key: 1,
  class: "text-white font-bold bg-black p-2 py-1 rounded-lg text-xs"
}
const _hoisted_34 = { class: "flex items-center gap-2 pt-1" }
const _hoisted_35 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"16px"},
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8V12",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16H12.01",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_39 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_45 = {
  key: 2,
  class: "text-xs text-gray-500"
}
const _hoisted_46 = { class: "grid grid-cols-12 gap-4 p-4" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "absolute top-0 w-full h-full px-2 py-2 rounded-2xl left-0",
  style: {"background":"rgb(0,0,0,0.2)"}
}
const _hoisted_49 = {
  key: 1,
  style: {"width":"auto"},
  class: "px-2 text-sm h-5 bg-red-500 rounded-xl text-white text-[10px] flex justify-center items-center relative overflow-hidden whitespace-nowrap"
}
const _hoisted_50 = {
  class: "p-4 sticky top-0 product-modal__addon-groups__addon-group__header",
  style: {"background":"#F9F9F9"}
}
const _hoisted_51 = { class: "flex items-center justify-between gap-2" }
const _hoisted_52 = { class: "font-semibold" }
const _hoisted_53 = {
  key: 0,
  class: "text-white font-bold bg-black p-2 py-1 rounded-lg text-xs"
}
const _hoisted_54 = {
  key: 1,
  class: "relative"
}
const _hoisted_55 = { class: "h-4 w-4 bg rounded-full relative z-10 bg-success" }
const _hoisted_56 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1rem","height":"1rem","z-index":"10"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute top-1/2 -translate-y-1/2 bg-success",
  style: {"width":"100%","height":"4px"}
}, null, -1)
const _hoisted_60 = { class: "flex items-center gap-2 pt-1" }
const _hoisted_61 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"min-width":"16px"},
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 8V12",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12 16H12.01",
  stroke: "#575757",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_65 = [
  _hoisted_62,
  _hoisted_63,
  _hoisted_64
]
const _hoisted_66 = { class: "flex items-center gap-2 justify-between w-full" }
const _hoisted_67 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 2 }
const _hoisted_71 = {
  key: 1,
  class: "text-xs text-gray-500"
}
const _hoisted_72 = {
  key: 2,
  class: "text-xs text-gray-500"
}
const _hoisted_73 = {
  key: 3,
  class: "text-xs font-bold"
}
const _hoisted_74 = { class: "text-success" }
const _hoisted_75 = { class: "flex flex-col" }
const _hoisted_76 = {
  style: {"height":"3rem"},
  class: "flex items-center gap-2"
}
const _hoisted_77 = ["src"]
const _hoisted_78 = { class: "lg:text-md text-sm" }
const _hoisted_79 = {
  key: 0,
  class: "text-white bg-green-500 text-[10px] rounded-xl px-2 py-0.5 font-semibold"
}
const _hoisted_80 = ["onClick"]
const _hoisted_81 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.2rem","height":"1.2rem"}
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H5V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_83 = [
  _hoisted_82
]
const _hoisted_84 = ["onClick"]
const _hoisted_85 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.2rem","height":"1.2rem"}
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_87 = [
  _hoisted_86
]
const _hoisted_88 = {
  key: 0,
  class: "flex items-center gap-4 pt-4 fixed bottom-0 box-shadow sm:shadow-none sm:mt-5 right-0 left-0 rounded-tl-2xl rounded-tr-2xl sm:rounded-2xl justify-between px-8 py-4 product-modal__add-to-cart bg-white"
}
const _hoisted_89 = { class: "flex gap-4 items-center" }
const _hoisted_90 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_91 = ["value"]
const _hoisted_92 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = ["disabled"]
const _hoisted_96 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-semibold" }, "Adicionar ao carrinho", -1)
const _hoisted_97 = { class: "font-bold text-start font-bold" }
const _hoisted_98 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_99 = {
  class: "h-full",
  style: {"background":"rgba(0,0,0,0.8)"}
}
const _hoisted_100 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_101 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_102 = [
  _hoisted_101
]
const _hoisted_103 = { class: "flex justify-center items-center h-full flex flex-col gap-8" }
const _hoisted_104 = ["src"]
const _hoisted_105 = { class: "w-full flex flex-col md:items-center md:justify-center" }
const _hoisted_106 = { class: "text-white text-bold text-lg w-full text-start px-4" }
const _hoisted_107 = { class: "text-white text-semibold text-sm w-full text-start px-4 only-1-lines" }

import MyModal from './MyModal.vue';
import { ref, watch, computed } from 'vue';
import { cart, restaurant, getProductImage } from '@/global/state/GlobalState';
import { useToast } from "vue-toastification";
import { ProductModel } from '@/models/ProductModel';

// eslint-disable-next-line no-undef
/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductModal',
  props: {
    selectedProduct: {},
    toggleModal: { type: Function },
    isOpen: { type: Boolean },
    setSelectedProduct: { type: Function },
    setSelectedProductVariations: { type: Function }
  },
  setup(__props: any) {

const props = __props

const quantity = ref<number>(1)
const addOnsQuantity = ref<any>({})
const canAddToCart = ref<boolean>(true)
const knowMore = ref<boolean>(false)
const isAmplifyImageModalOpen = ref<boolean>(false)
const toast = useToast()

const variantGroups = ref<any[]>([])

function displayDescription(description?: string){
  if(description && description?.length > 184){
    if(knowMore.value){
      return description
    }
    return description.substring(0, 164) + '...'
  }
  return description
}

function handleModalScroll(e: any){
  const productTitleNav = document.querySelector('#product-title-nav') as HTMLElement
  const modalProductTitle = document.querySelector('#product-modal__product-name') as HTMLElement
  if(productTitleNav && modalProductTitle){
      if(e.target.scrollTop >= modalProductTitle.offsetTop){
          productTitleNav.classList.add('show-title')
      } else{
          productTitleNav.classList.remove('show-title')
      }
  }
}

watch(() => props.selectedProduct, (newProduct: ProductModel) => {
    let values: any = {}
    knowMore.value = false
    
    if(newProduct.addOnGroups){
      newProduct.addOnGroups.forEach((addonGroup: any, index: number) => {
          if(!values[index]){
            values[index] = { totalQuantity: 0, name: addonGroup.name, addons: {} }
          }
          if(addonGroup.addOns) {
            addonGroup.addOns.forEach((addon: any) => {
              values[index].addons[addon.id] = { 
                name: addon.name, 
                quantity: 0, 
                price: addon.price, 
                id: addon.id 
              }
            })
          }
      })
      addOnsQuantity.value = values
    }

    if(newProduct.variantGroups){
      variantGroups.value = JSON.parse(JSON.stringify(newProduct.variantGroups)).map((variation: any) => {
        variation.variants = variation.variants.map((op: any) => {
          op.selected = false
          return op
        })
        return variation
      })
    } else {
      variantGroups.value = []
    }
    
    quantity.value = 1
}, { deep: false})

watch(() => variantGroups.value, (newProductVariations, oldProductVariations) => {
    let required: boolean[] = []
    let min: boolean[] = []
    let max: boolean[] = []
    let errorMessage = ''

    if(newProductVariations){
      newProductVariations.forEach((variation: any, index: number) => {
        let selectedOptions = variation.variants.filter((option: any) => option.selected)
        let oldSelectedOptions = oldProductVariations?.length === newProductVariations.length 
          ? oldProductVariations[index]?.variants.filter((option: any) => option.selected) || []
          : []

        if(variation.required){
          required.push(selectedOptions.length ? true : false)
        }

        const minChoices = variation.minimumChoices || (variation.required ? 1 : 0)
        if(selectedOptions.length < minChoices && oldSelectedOptions.length > selectedOptions.length){
            errorMessage = `Você precisa selecionar no mínimo ${minChoices} iten(s) em ${variation.name}`
        }
        min.push(selectedOptions.length >= minChoices)

        if(variation.maximumChoices && selectedOptions.length > variation.maximumChoices){
           errorMessage = `Você pode selecionar no máximo ${variation.maximumChoices} iten(s) em ${variation.name}`
        }
        max.push(!variation.maximumChoices || selectedOptions.length <= variation.maximumChoices)
      })

      canAddToCart.value = required.every((bool: boolean) => bool) && min.every((bool: boolean) => bool) && max.every((bool: boolean) => bool)

      if(!canAddToCart.value && errorMessage){
        toast.warning(errorMessage, {timeout: 2000})
      }
    }
}, { deep: true })

const areAddonGroupsRequirementsFulfilled = computed<boolean>(() => {
  if (!props.selectedProduct.addOnGroups) return true
  
  return props.selectedProduct.addOnGroups.every((addonGroup: any, index: number) => {
    const totalQty = addOnsQuantity.value[index]?.totalQuantity || 0
    const minChoices = addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)
    
    if (addonGroup.required) {
      return totalQty >= minChoices
    } else {
      if ((addonGroup.minimumChoices || 0) > 0 && totalQty > 0) {
        return totalQty >= addonGroup.minimumChoices
      }
      return true
    }
  })
})

const totalPrice = computed<number>(() => {
    let basePrice = props.selectedProduct.promotionalPrice && props.selectedProduct.promotionalPrice < props.selectedProduct.price 
      ? props.selectedProduct.promotionalPrice 
      : props.selectedProduct.price
    let total: number = quantity.value * basePrice

    for(let addonGroupIndex in addOnsQuantity.value){
      for(let addonId in addOnsQuantity.value[addonGroupIndex].addons){
        total += (addOnsQuantity.value[addonGroupIndex].addons[addonId].quantity * quantity.value) * parseFloat(addOnsQuantity.value[addonGroupIndex].addons[addonId].price || '0')
      }
    }

    variantGroups.value.forEach((variation: any) => {
        variation.variants.forEach((option: any) => {
            if(option.selected){
                total += (option.price || 0) * quantity.value;
            }
        })
    })

    return total
})

function handleAddonsQuantity(addonGroupIndex: any, id: any, value: any){
  const addonGroup = props.selectedProduct.addOnGroups?.[addonGroupIndex]
  if (!addonGroup) return

  const currentTotal = addOnsQuantity.value[addonGroupIndex].totalQuantity
  if (value > 0 && addonGroup.maximumChoices && currentTotal >= addonGroup.maximumChoices) {
    toast.warning(`Máximo de ${addonGroup.maximumChoices} itens atingido!`)
    return
  }
  
  if (value < 0 && addOnsQuantity.value[addonGroupIndex].addons[id].quantity <= 0) return

  addOnsQuantity.value[addonGroupIndex].addons[id].quantity += value
  addOnsQuantity.value[addonGroupIndex].totalQuantity += value
}

function selectVariationOption(option: any, variationIndex: number){
  const variation = variantGroups.value[variationIndex];
  
  if(variation.selectionType === 'single'){
    variation.variants.forEach((opt: any) => {
      if (opt !== option) opt.selected = false
    })
    option.selected = !option.selected
  } else {
    // Multiple selection
    if (!option.selected && variation.maximumChoices && variation.variants.filter((v: any) => v.selected).length >= variation.maximumChoices) {
      toast.warning(`Máximo de ${variation.maximumChoices} itens atingido!`)
      return
    }
    option.selected = !option.selected
  }
}

function addToCart(): void{
    const addonsQuantityFormated = Object.keys(addOnsQuantity.value)
    .filter((addonGroupIndex) => {
      return addOnsQuantity.value[addonGroupIndex].totalQuantity > 0;
    }).map((addonGroupIndex) => {
      let addonGroup = JSON.parse(JSON.stringify(addOnsQuantity.value[addonGroupIndex]))
      addonGroup.addons = Object.keys(addonGroup.addons)
        .filter((id: any) => addonGroup.addons[id].quantity > 0)
        .map((id: any) => addonGroup.addons[id])

      return {
        id: addonGroup.id,
        name: addonGroup.name,
        addons: addonGroup.addons
      }
    });

    if(canAddToCart.value && areAddonGroupsRequirementsFulfilled.value){
        let cartItems = JSON.parse(localStorage.getItem('cart') as string) ?? []
        
        let productVariations = variantGroups.value
          .filter((v: any) => v.variants.some((op: any) => op.selected))
          .map((v: any) => ({
            name: v.name,
            values: {
              label: v.variants.filter((op: any) => op.selected).map((op: any) => op.name),
              prices: v.variants.filter((op: any) => op.selected).map((op: any) => op.price || 0),
            ids: v.variants.filter((op: any) => op.selected).map((op: any) => op.id),
            groupId: v.id
          }
        }))

        const alreadyInCartIndex = cartItems.findIndex((item: any) => {
          return item.id === props.selectedProduct.id && 
                 item.variations === JSON.stringify(productVariations) &&
                 JSON.stringify(item.addon_groups) === JSON.stringify(addonsQuantityFormated)
        })

        if(alreadyInCartIndex !== -1){
          cartItems[alreadyInCartIndex].quantity += quantity.value
        } else {
            cartItems.push({
                ...props.selectedProduct,
                variations: JSON.stringify(productVariations),
                quantity: quantity.value, 
                addon_groups: addonsQuantityFormated, 
                organizationId: restaurant.value.id
            })
        }

        cart.value = cartItems
        localStorage.setItem('cart', JSON.stringify(cartItems))
        
        props.setSelectedProduct({})
        quantity.value = 1
        toast.success('Item adicionado ao carrinho!', {timeout:1500})
        props.toggleModal(false)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MyModal, {
      width: '50rem',
      height: '38rem',
      isOpen: _ctx.isOpen,
      toggleModal: _ctx.toggleModal,
      zIndex: 200,
      id: 'product-modal'
    }, {
      default: _withCtx(() => [
        (_ctx.selectedProduct.name)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "font-inter relative product-modal overflow-auto pb-4 md:pb-0",
              onScroll: _cache[7] || (_cache[7] = ($event: any) => (handleModalScroll($event)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "transition duration-200 hover:text-primary p-2 rounded-full box-shadow bg-white justify-self-start left-4",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.toggleModal(!_ctx.isOpen);_ctx.setSelectedProduct({})})
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                ]),
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.selectedProduct.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "rounded-xl h-60 w-full object-contain main-product-image",
                      src: _unref(getProductImage)(_ctx.selectedProduct),
                      alt: "Imagem do produto",
                      srcset: "",
                      onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("button", {
                      class: "absolute top-4 right-4 box-shadow p-2 rounded-lg",
                      style: {"background":"rgba(255, 255, 255, 0.8)","z-index":"201"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isAmplifyImageModalOpen.value = true))
                    }, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.selectedProduct.name), 1),
                      _createElementVNode("p", _hoisted_15, [
                        _createTextVNode(_toDisplayString(displayDescription(_ctx.selectedProduct.description as string)) + " ", 1),
                        (!knowMore.value && (_ctx.selectedProduct.description?.length ?? 0) > 184)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (knowMore.value = true)),
                              class: "text-primary font-semibold uppercase underline"
                            }, "saiba mais"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.selectedProduct.promotionalPrice && _ctx.selectedProduct.promotionalPrice < _ctx.selectedProduct.price)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.selectedProduct.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedProduct.promotionalPrice && _ctx.selectedProduct.promotionalPrice < _ctx.selectedProduct.price)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("p", null, [
                              _hoisted_21,
                              _createTextVNode(),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedProduct.promotionalPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.selectedProduct.promotionalPrice || _ctx.selectedProduct.promotionalPrice >= _ctx.selectedProduct.price)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.selectedProduct.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1))
                        : _createCommentVNode("", true)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variantGroups.value, (variation, variationIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "product-modal__right__variation",
                        key: variationIndex
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("h6", _hoisted_26, _toDisplayString(variation.name), 1),
                            (variation.required && variation.variants.filter((option) => option.selected).length >= (variation.minimumChoices || 1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_29, _hoisted_31))
                                  ]),
                                  _hoisted_32
                                ]))
                              : (variation.required)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "obrigatório"))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_35, _hoisted_39)),
                            ((variation.minimumChoices || (variation.required ? 1 : 0)) > 1 || variation.maximumChoices)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                                  ((variation.minimumChoices || (variation.required ? 1 : 0)) > 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, "mínimo " + _toDisplayString(variation.minimumChoices || 1), 1))
                                    : _createCommentVNode("", true),
                                  ((variation.minimumChoices || (variation.required ? 1 : 0)) > 1 && variation.maximumChoices)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, " e "))
                                    : _createCommentVNode("", true),
                                  (variation.maximumChoices)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, "máximo " + _toDisplayString(variation.maximumChoices), 1))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" iten(s) ")
                                ]))
                              : (variation.required)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_44, "Selecione pelo menos uma opção"))
                                : (_openBlock(), _createElementBlock("p", _hoisted_45, "Iten(s) opcionais"))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variation.variants, (option, optionIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              onClick: ($event: any) => (selectVariationOption(option, variationIndex)),
                              style: _normalizeStyle([{"height":"6.5rem","background-position":"center","background-size":"cover"}, {backgroundImage:option.media?.length ? `url('${_unref(getProductImage)(option, true)}')`:'unset'}]),
                              key: optionIndex,
                              class: _normalizeClass(["relative cursor-pointer px-2 py-2 rounded-2xl font-bold transition-colors duration-200 w-full col-span-4 flex justify-center items-center flex-col gap-2 shadow-sm", option.selected ? 'border-2 border-green-500':`${option.media?.length ? 'border-white border-2':'border lg:hover:border-2'} lg:hover:border-neutral-700`])
                            }, [
                              (option.media?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: _normalizeClass(option.media?.length ? 'text-white relative text-sm text-center drop-shadow-md':'text-center text-sm')
                              }, _toDisplayString(option.name), 3),
                              ((option.price || 0) > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, "+" + _toDisplayString((option.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1))
                                : _createCommentVNode("", true)
                            ], 14, _hoisted_47))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProduct.addOnGroups, (addonGroup, addonGroupIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "product-modal__addon-groups__addon-group",
                        key: addonGroupIndex
                      }, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("h6", _hoisted_52, _toDisplayString(addonGroup.name), 1),
                            (addonGroup.required && (addOnsQuantity.value[addonGroupIndex]?.totalQuantity ?? 0) < (addonGroup.minimumChoices || 1))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, "obrigatório"))
                              : (addonGroup.required)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_56, _hoisted_58))
                                    ]),
                                    _hoisted_59
                                  ]))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            (_openBlock(), _createElementBlock("svg", _hoisted_61, _hoisted_65)),
                            _createElementVNode("div", _hoisted_66, [
                              ((addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1 || addonGroup.maximumChoices)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_67, [
                                    ((addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "mínimo " + _toDisplayString(addonGroup.minimumChoices || 1), 1))
                                      : _createCommentVNode("", true),
                                    ((addonGroup.minimumChoices || (addonGroup.required ? 1 : 0)) > 1 && addonGroup.maximumChoices)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_69, " e "))
                                      : _createCommentVNode("", true),
                                    (addonGroup.maximumChoices)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_70, "máximo " + _toDisplayString(addonGroup.maximumChoices), 1))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" iten(s) ")
                                  ]))
                                : (addonGroup.required)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_71, "Selecione pelo menos um item"))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_72, "Iten(s) opcionais")),
                              (addOnsQuantity.value[addonGroupIndex]?.totalQuantity && addonGroup.maximumChoices)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                                    _createElementVNode("span", _hoisted_74, _toDisplayString(addOnsQuantity.value[addonGroupIndex]?.totalQuantity), 1),
                                    _createTextVNode("/" + _toDisplayString(addonGroup.maximumChoices), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addonGroup.addOns, (addon, addonIndex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: addonIndex,
                              class: _normalizeClass(["w-full flex items-center justify-between p-4 mt-1 pb-5", addonIndex !== addonGroup.addOns.length - 1 ? 'border-b':''])
                            }, [
                              _createElementVNode("div", _hoisted_76, [
                                (addon.media?.length)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "rounded-lg object-cover",
                                      style: {"height":"4rem","width":"4rem"},
                                      src: _unref(getProductImage)(addon, true),
                                      alt: "Imagem do complemento",
                                      onError: _cache[4] || (_cache[4] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                                    }, null, 40, _hoisted_77))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h6", _hoisted_78, _toDisplayString(addon.name), 1),
                                  (addon.price)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_79, "+" + _toDisplayString(addon.price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex gap-4 items-center text-sm py-2 rounded-lg pr-2", addOnsQuantity.value[addonGroupIndex]?.addons[addon.id]?.quantity ? 'border px-2':'']),
                                style: {"transition":"padding .2s"}
                              }, [
                                (addOnsQuantity.value[addonGroupIndex]?.addons[addon.id]?.quantity)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "transition duration-200 hover:text-green-500",
                                      onClick: ($event: any) => (handleAddonsQuantity(addonGroupIndex, addon.id, -1))
                                    }, [
                                      (_openBlock(), _createElementBlock("svg", _hoisted_81, _hoisted_83))
                                    ], 8, _hoisted_80))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(addOnsQuantity.value[addonGroupIndex]?.addons[addon.id]?.quantity ? addOnsQuantity.value[addonGroupIndex]?.addons[addon.id]?.quantity:'') + " ", 1),
                                _createElementVNode("button", {
                                  class: "transition duration-200 hover:text-green-500",
                                  onClick: ($event: any) => (handleAddonsQuantity(addonGroupIndex, addon.id, +1))
                                }, [
                                  (_openBlock(), _createElementBlock("svg", _hoisted_85, _hoisted_87))
                                ], 8, _hoisted_84)
                              ], 2)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (!_unref(restaurant).restaurantConfig?.isDigitalCatalog)
                ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("button", {
                        class: "transition duration-200 hover:text-green-500",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (quantity.value <= 1 ? '':quantity.value--))
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_90, [
                          _createElementVNode("path", {
                            d: "M19,13H5V11H19V13Z",
                            style: _normalizeStyle({fill: quantity.value <= 1 ? '#ccc' : 'currentcolor'})
                          }, null, 4)
                        ]))
                      ]),
                      _createElementVNode("input", {
                        type: "text",
                        class: "w-3 text-center",
                        value: quantity.value,
                        readonly: ""
                      }, null, 8, _hoisted_91),
                      _createElementVNode("button", {
                        class: "transition duration-200 hover:text-green-500",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (quantity.value++))
                      }, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_92, _hoisted_94))
                      ])
                    ]),
                    _createElementVNode("button", {
                      disabled: !canAddToCart.value || !areAddonGroupsRequirementsFulfilled.value,
                      onClick: addToCart,
                      class: "flex items-center justify-between p-3 md:p-4 rounded-2xl transition duration-200 font-inter",
                      style: _normalizeStyle({background: canAddToCart.value && areAddonGroupsRequirementsFulfilled.value ? _unref(restaurant).restaurantDesignCustom?.primaryColor ? _unref(restaurant).restaurantDesignCustom.primaryColor : '#323232' : '#f5f5f5', color: canAddToCart.value && areAddonGroupsRequirementsFulfilled.value ? 'var(--sf-on-primary, #fff)' : '#949494'})
                    }, [
                      _createElementVNode("div", null, [
                        _hoisted_96,
                        _createElementVNode("p", _hoisted_97, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1)
                      ]),
                      (_openBlock(), _createElementBlock("svg", _hoisted_98, [
                        _createElementVNode("path", {
                          d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
                          style: _normalizeStyle({fill: canAddToCart.value && areAddonGroupsRequirementsFulfilled.value ? '#fff' : '#949494'})
                        }, null, 4)
                      ]))
                    ], 12, _hoisted_95)
                  ]))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      width: '100%',
      height: '100%',
      className: '',
      id: 'amplify-image-modal',
      isOpen: isAmplifyImageModalOpen.value,
      toggleModal: (v) => isAmplifyImageModalOpen.value = v,
      zIndex: 201
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("button", {
            class: "transition duration-200 hover:text-primary p-2 rounded-full justify-self-start left-4 absolute top-3",
            onClick: _cache[8] || (_cache[8] = ($event: any) => {isAmplifyImageModalOpen.value = false;_ctx.toggleModal(true)})
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_100, _hoisted_102))
          ]),
          _createElementVNode("div", _hoisted_103, [
            _createElementVNode("img", {
              style: {"height":"20rem"},
              src: _unref(getProductImage)(_ctx.selectedProduct),
              alt: "Imagem do produto",
              srcset: "",
              onError: _cache[9] || (_cache[9] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
            }, null, 40, _hoisted_104),
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("p", _hoisted_106, _toDisplayString(_ctx.selectedProduct.name), 1),
              _createElementVNode("p", _hoisted_107, _toDisplayString(_ctx.selectedProduct.description), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})